import { render, staticRenderFns } from "./RedBannerButton.vue?vue&type=template&id=8b568e26"
import script from "./RedBannerButton.vue?vue&type=script&lang=js"
export * from "./RedBannerButton.vue?vue&type=script&lang=js"
import style0 from "./RedBannerButton.vue?vue&type=style&index=0&id=8b568e26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports